module.exports = __webpack_public_path__ + "img/synopsis2.bebbcf8.svg";